import React from 'react';
import { spaceMixin, Flex, Text } from '@zillow/constellation';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useLastValidRefinanceValues, useRefinanceColors } from './RefinanceCalculator.utils.js';
import { getWholeDollars } from '../../utils/zhl-calculator.js';

var StyledLegendCircle = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-19u1ay0-0"
})(["background-color:", ";width:8px;height:8px;border-radius:4px;margin-right:", ";display:inline-block;min-width:8px;"], function (_ref) {
  var color = _ref.color;
  return color;
}, spaceMixin('xs'));
var StyledLegendItem = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-19u1ay0-1"
})(["display:flex;align-items:center;"]);
var RefinanceLegend = function RefinanceLegend(_ref2) {
  var className = _ref2.className;
  var values = useLastValidRefinanceValues();
  var colors = useRefinanceColors();
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodyHeading"
  }, "Monthly savings"), /*#__PURE__*/React.createElement(Text, null, getWholeDollars(values.calculations.monthlySavings), " /mo")), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodyHeading"
  }, "New payment"), /*#__PURE__*/React.createElement(Text, null, getWholeDollars(values.calculations.newPayment))), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodyHeading"
  }, "Break even"), values.calculations.breakEven && /*#__PURE__*/React.createElement(Text, null, values.calculations.breakEven, ' ', values.calculations.breakEven === 1 ? 'month' : 'months'), !values.calculations.breakEven && /*#__PURE__*/React.createElement(Text, null, "N/A")), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(StyledLegendItem, {
    fontType: "bodyHeading"
  }, /*#__PURE__*/React.createElement(StyledLegendCircle, {
    color: colors.costsColor
  }), "Costs"), /*#__PURE__*/React.createElement(Text, null, getWholeDollars(values.fields.fees))), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(StyledLegendItem, {
    fontType: "bodyHeading"
  }, /*#__PURE__*/React.createElement(StyledLegendCircle, {
    color: colors.lifetimeSavingsColor
  }), "Lifetime savings"), /*#__PURE__*/React.createElement(Text, null, getWholeDollars(values.calculations.lifetimeSavings))));
};
RefinanceLegend.defaultProps = {
  className: undefined
};
RefinanceLegend.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
var RefinanceLegend$1 = RefinanceLegend;

export { RefinanceLegend$1 as default };
